import { eventTracking } from './tracking'

function getCookie(name) {
  let cookie;

  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      cookie = parts.pop().split(';').shift();
    }
  } catch (e) {
    eventTracking(e.message, "recommendation_new")
  }

  return cookie;
}

function getExperimentationCookie(name) {
  let variant = '';
  let cookie = '';

  try {
    const value = `; ${document.cookie}`;
    const parts = value.split(`${name}=`).pop();
    cookie = parts.split(';').shift();
    variant = cookie.split("_").pop();
  } catch(e) {
    eventTracking(e.message, "recommendation_new")
  }

  return variant;
}

export { getCookie, getExperimentationCookie };



// WEBPACK FOOTER //
// ./src/scripts/common.js